import React from 'react';
import { AlertCircleIcon } from './Icons';
import './ConfirmDialog.css';

const ConfirmDialog = ({ isOpen, title, message, confirmText = 'Confirm', cancelText = 'Cancel', onConfirm, onCancel, type = 'info' }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className="confirm-dialog-overlay" onClick={handleCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog__header">
          <div className="confirm-dialog__icon-wrapper">
            <AlertCircleIcon className={`confirm-dialog__icon confirm-dialog__icon--${type}`} size={24} />
          </div>
          <h3 className="confirm-dialog__title">{title}</h3>
        </div>
        <div className="confirm-dialog__content">
          <p className="confirm-dialog__message">{message}</p>
        </div>
        <div className="confirm-dialog__actions">
          <button
            onClick={handleCancel}
            className="confirm-dialog__btn confirm-dialog__btn--cancel"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={`confirm-dialog__btn confirm-dialog__btn--${type}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;










